import React from "react";
import withStyles from "react-jss";
import PropTypes from "prop-types";
import { setDisplayName } from "recompose";
import classNames from "classnames";

const titleStyle = (theme) => ({
	root: {
		marginBottom: "26px",
		"& span": {
			fontFamily: theme.fonts.medium,
			fontSize: "14px",
			lineHeight: "1.43",
			letterSpacing: "2px",
			color: theme.palette.colors.oneMoreGrey,
			textTransform: "uppercase",
		},
		"& .bold": {
			color: theme.palette.colors.headerColour,
		},
	},
	homeOrder: {
		margin: "40px 20%",
	},
	[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
		root: {
			marginBottom: 0,
			marginTop: "8px",
		},
		homeOrder: {
			margin: "40px 20%",
		},
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		homeOrder: {
			width: "100%",
			margin: "40px 0",
		},
	},
});

const Title = withStyles(titleStyle)(({ children, classes, homeOrder }) => {
	return (
		<div
			className={classNames(classes.root, {
				[classes.homeOrder]: homeOrder,
			})}
		>
			{children}
		</div>
	);
});

Title.propTypes = {
	children: PropTypes.node,
};
export default setDisplayName("TitleForm")(Title);
